import { cn } from "@newxsystems/shared";
import { GroundCardLink } from "../GroundCardLink/GroundCardLink";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div className={cn("grid grid-cols-1 sm:grid-cols-2", columns[columnCount || 3])}>
    {items.map((item, index) => (
      <GroundCardLink
        className="flex flex-col border-b border-r border-weathered-steel first:border-l"
        key={index}
        link={item.cardLink}
      >
        <div className="flex-1 p-7 md:p-9">
          <h3 className="font-ground-display text-3xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <GroundRichText
              className="mt-4 text-base text-basalt md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
        <GroundMedia
          aspectRatio={imageAspectRatio || "16:9"}
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </GroundCardLink>
    ))}
  </div>
);

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
